import React from "react";
import { Tabs, Tab } from "@mui/material";

export default function SubBar({ activeTab, setActiveTab }) {
  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };

  return (
    <Tabs value={activeTab} onChange={handleChange} textColor="primary" indicatorColor="primary">
      <Tab label="USER" />
      <Tab label="PROPERTIES" />
      <Tab label="PERMISSIONS" />
    </Tabs>
  );
}
